import { render, staticRenderFns } from "./ChooseProject.vue?vue&type=template&id=73dde7f4&scoped=true&"
import script from "./ChooseProject.vue?vue&type=script&lang=js&"
export * from "./ChooseProject.vue?vue&type=script&lang=js&"
import style0 from "./ChooseProject.vue?vue&type=style&index=0&id=73dde7f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dde7f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VAvatar,VCard,VChip,VContainer,VDivider,VIcon,VSubheader})
